// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__1fohX","label":"PriceFilterPopup_label__2DNgo","labelSelected":"PriceFilterPopup_labelSelected__2ajX5"};